<div class="">
    <img src="assets/images/hr-ad.jpg" alt="" width="78%" height="auto">
  </div>